import { Box, Pagination, Typography } from '@mui/material';
import { useTranslation } from '@/kit/useTranslation';

export default function TransactionPagination({ page, totalPages, onPageChange, totalCount }) {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        mt: 3,
        pb: 2,
        px: 1,
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t('payment.transactions.pageInfo', { page, totalPages, totalCount })}
      </Typography>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          '& .MuiPagination-ul': {
            flexWrap: 'nowrap',
            justifyContent: 'center',
          },
        }}
      >
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, value) => onPageChange(value)}
          color="primary"
          size="medium"
          showFirstButton={totalPages > 3}
          showLastButton={totalPages > 3}
          siblingCount={0}
          boundaryCount={1}
        />
      </Box>
    </Box>
  );
}
